import { sdk } from '../sdk';

export interface DashboardData {
  period: {
    days: number;
    startDate: string;
    endDate: string;
  };
  summary: {
    donations: {
      count: number;
      amount: number;
      averageAmount: number;
      change: { count: number; amount: number };
    };
    expenses: {
      count: number;
      amount: number;
      averageAmount: number;
      change: { count: number; amount: number };
    };
    netCashFlow: {
      amount: number;
      change: number;
    };
    donors: {
      permanent: number;
      guest: number;
      total: number;
    };
    offices: number;
    regions: number;
    accounts: number;
  };
  breakdowns: {
    donationsByType: Array<{
      typeId: string;
      typeName: string;
      count: number;
      amount: number;
      percentage: string;
    }>;
    expensesByType: Array<{
      typeId: string;
      typeName: string;
      count: number;
      amount: number;
      percentage: string;
    }>;
  };
  trends: {
    daily: Array<{ date: string; count: number; amount: number }>;
    weekly: Array<{ year: number; week: number; count: number; amount: number }>;
    monthly: Array<{ year: number; month: number; count: number; amount: number }>;
  };
  topPerformers: {
    donors: Array<{ donorId: string; donorName: string; donorType: string; count: number; amount: number }>;
    offices: Array<{ officeId: string; officeName: string; count: number; amount: number; donorCount: number }>;
    regions: Array<{ regionId: string; regionName: string; count: number; amount: number }>;
  };
  recentActivity: {
    donations: Array<{ receiptId: string; donorName: string; amount: number; type: string; office: string; date: string }>;
    expenses: Array<{ expenseId: string; description: string; amount: number; type: string; office: string; date: string }>;
  };
  accounts: Array<{ accountId: string; name: string; balance: number; type: string }>;
  generatedAt: string;
  userRole: string;
}

export const DashboardAPI = {
  getDashboard: async (period: string = '30'): Promise<DashboardData> => {
    const response = await sdk.client.get(`/api/v1/reports/dashboard?period=${period}`);
    if (!response.success || !response.data) {
      throw new Error(response.message || 'Failed to fetch dashboard data');
    }
    return response.data;
  },
};
